import {SET_MEASUREMENT_TO_IMPERIAL, SET_MEASUREMENT_TO_METRIC} from '../constants';

export const setMeasurementUnitToMetric = () => ({
    type: SET_MEASUREMENT_TO_METRIC,
});

export const setMeasurementUnitToImperial = () => ({
    type: SET_MEASUREMENT_TO_IMPERIAL,
});